import { createSelector } from "reselect";
export const getWasteDisposalList = ({ WasteDisposalSiteList_reducer }) => {
    return WasteDisposalSiteList_reducer.wasteDisposalSiteList;
};

export const selectWasteDisposalList = createSelector(
    [getWasteDisposalList],
    sites => {
        if (sites) {
            return Object.keys(sites).map(e => {
                return { key: e, site: sites[e] };
            });
        }
        return [];
    }
);
